/**
 * Pure helpers for `InlineConstraintForm`. Extracted from the JSX
 * file so the picker grouping logic is testable without a render
 * harness — the form still uses these via re-export.
 */

/**
 * Group constraint types by category for the picker dropdown,
 * optionally dropping any whose code is in `excludeCodes`. Used by
 * the per-team picker to hide types that have a dedicated editing
 * surface elsewhere (e.g. `pair_matchup_count` lives in Matchup
 * Config, not the per-team picker).
 */
export const groupConstraintTypesForPicker = <
  T extends { code: string; category: string }
>(
  constraintTypes: T[],
  excludeCodes?: readonly string[]
): Map<string, T[]> => {
  const visible =
    excludeCodes && excludeCodes.length > 0
      ? constraintTypes.filter((t) => !excludeCodes.includes(t.code))
      : constraintTypes
  const groups = new Map<string, T[]>()
  visible.forEach((t) => {
    const existing = groups.get(t.category) || []
    existing.push(t)
    groups.set(t.category, existing)
  })
  return groups
}
